import { render, staticRenderFns } from "./GrowtradeOnboarding.vue?vue&type=template&id=0b617230&scoped=true&"
import script from "./GrowtradeOnboarding.vue?vue&type=script&lang=js&"
export * from "./GrowtradeOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./GrowtradeOnboarding.vue?vue&type=style&index=0&id=0b617230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b617230",
  null
  
)

export default component.exports